import React from 'react';

/**
 * Sandbox anti-cheat obavijest: prikazuje se umjesto ispitnog modula (okružnice/SOP/edukacije/newsletteri)
 * kad ga ne-admin pokuša otvoriti na vježbalištu. Samo-sadržan (bez teških ovisnosti), magenta sandbox akcent.
 */
export function SandboxBlockedNotice({
    moduleTitle,
    locale,
}: {
    moduleTitle: string;
    locale: 'hr' | 'en';
}) {
    const message =
        locale === 'en'
            ? 'This module is available only in the real (production) environment.'
            : 'Ovo je modul dostupan samo u stvarnom (produkcijskom) okruženju.';
    const sub =
        locale === 'en'
            ? 'Train on production — this content is intentionally hidden in the sandbox.'
            : 'Treniraj na produkciji — ovaj sadržaj je namjerno skriven na vježbalištu.';

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '48px 20px',
            }}
        >
            <div
                style={{
                    maxWidth: 520,
                    width: '100%',
                    textAlign: 'center',
                    background: '#fdf4ff',
                    border: '2px solid #c026d3',
                    borderRadius: 16,
                    padding: '36px 32px',
                    boxShadow: '0 8px 28px rgba(192, 38, 211, 0.18)',
                }}
            >
                <div style={{ fontSize: 48, lineHeight: 1, marginBottom: 14 }} aria-hidden="true">
                    🔒
                </div>
                <h2
                    style={{
                        margin: '0 0 14px',
                        fontSize: 20,
                        fontWeight: 700,
                        color: '#86198f',
                    }}
                >
                    {moduleTitle}
                </h2>
                <p style={{ margin: '0 0 12px', fontSize: 15, color: '#4a044e', fontWeight: 600 }}>
                    {message}
                </p>
                <p style={{ margin: 0, fontSize: 13, color: '#a21caf', fontStyle: 'italic' }}>{sub}</p>
            </div>
        </div>
    );
}
